module.exports = __webpack_public_path__ + "assets/images/project/constituencies/pioneer-smc.jpg?v=18fefa54";